export const isNodeWiderThanParent = ({ current }) => {
  if (!current) {
    return false;
  }

  const nodeWidth = current.getBoundingClientRect().width;
  const nodeParentWidth = current.parentNode.getBoundingClientRect().width;

  return nodeWidth > nodeParentWidth;
};

export default isNodeWiderThanParent;
